import { CommonModal } from '@sketch-note/design-system/src/components/modal';
import { Input } from '@sketch-note/design-system/src/components/text-input';
import { logoutUser } from '@sketch-note/design-system/src/shared/utils';
import { DropdownTwo } from '@sketchnote/shared-components';
import * as React from 'react';
import { useForm, useFormState } from 'react-hook-form';

import { useProfileStore, useSettings } from '../../store';

const { useState } = React;

export const DeleteAccount = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): JSX.Element => {
  interface Values {
    challenge: string;
  }
  const [isOpenFeedBack, setIsOpenFeedback] = useState(false);
  const { register, control, setError, getValues, clearErrors } = useForm<Values>();
  const { errors } = useFormState({ control });
  const { emailId } = useProfileStore((state) => state);

  const [callbacks] = useSettings();

  const handleFeedbackOpen = () => {
    setIsOpenFeedback(true);
  };
  const handleFeedbackClose = () => {
    setIsOpenFeedback(false);
    onClose();
  };
  const handleSubmit = async () => {
    clearErrors();
    if (getValues('challenge')) {
      const response = await callbacks?.onDeleteAccount?.({ challenge: getValues('challenge') });

      if (response?.isSuccess) {
        onClose();
        logoutUser();
      } else {
        setError('challenge', { message: 'Oops! Try again' });
      }
    } else {
      setError('challenge', { message: 'Type the above text' });
    }
  };
  return (
    <div>
      <CommonModal
        isOpen={isOpen}
        headText="Here's what happens when you delete your account"
        footerMainLabel="Delete account"
        footerSecLabel="Cancel"
        onClose={onClose}
        onMainClick={handleFeedbackOpen}
        onSecClick={onClose}
        contentStyle={{ width: '460px' }}
        footerButtonStatus="danger"
      >
        <ul className="list-disc list-inside">
          <li>You will lose all your content. This action can&apos;t be undone </li>
          <li className="mt-24">
            You&apos;ll have to re-register at sketchnote starting from scratch
          </li>
        </ul>
      </CommonModal>
      <CommonModal
        isOpen={isOpenFeedBack}
        headText="We are sorry to see you leave!"
        footerMainLabel="Delete account"
        footerSecLabel="Cancel"
        onClose={handleFeedbackClose}
        onSecClick={handleFeedbackClose}
        onMainClick={handleSubmit}
        contentStyle={{ width: '735px' }}
        footerButtonStatus="danger"
      >
        <DropdownTwo
          required={true}
          className="mt-32 w-full"
          label="I'm leaving because..."
          placeholder="--Choose an option--"
          options={[
            {
              value: 'i-dont-have-use-for-sketchnote-any-longer',
              label: 'I don’t have use for Sketchnote any longer',
            },
            {
              value: 'i-dont-find-the-content-or-creations-on-sketchnote-relevant-any-longe',
              label: 'I don’t find the content or creations on Sketchnote relevant any longer',
            },
            {
              value: 'im-using-a-different-documentation-softwarecollaboration-tool',
              label: 'I’m using a different documentation software/collaboration tool',
            },
            { value: 'i-have-issues-with-the-pricing', label: 'I have issues with the pricing' },
            { value: 'other', label: 'Other' },
          ]}
        />
        <DropdownTwo
          required={true}
          className="mt-32 w0"
          label="How do you think we can do better?"
          placeholder="--Choose how Sketchnote could improve--"
          options={[
            {
              value: 'more-relevant-content-and-creations',
              label: 'More relevant content and creations',
            },
            {
              value: 'more-tools-and-options-for-collaboration-and-documentation',
              label: 'More tools and options for collaboration and documentation',
            },
            {
              value: 'decrease-pricing-for-pro-or-team-plans',
              label: 'Decrease pricing for pro or team plans',
            },
            { value: 'others', label: 'Other' },
          ]}
        />
        <Input
          required={true}
          labelClassName="mt-24"
          wrapperClassName="pt-7 pb-7 px-12"
          label={`Type "Delete ${emailId}`}
          inputProps={{
            ...register('challenge', {
              required: true,
            }),
          }}
          placeholder="Enter Text"
          status={errors.challenge ? 'danger' : undefined}
          caption={errors?.challenge?.message}
        />
        <p className="text-xss">
          We need you to do this for account verification and prevention of unauthorized account
          deletion
        </p>
      </CommonModal>
    </div>
  );
};
